import client, { setOrderingToken } from './client';

export type DeviceTier = { id: number; min_qty: number; unit_price_minor: number; currency: string };
export type Device = { id: number; name: string; description?: string|null; device_uid: string; image_key?: string|null; base_price_minor: number; currency: string; DevicePriceTiers?: DeviceTier[] };
export type Country = { id: string; name: string };
export type PricingRole = 'MERCHANT' | 'DISTRIBUTOR';

export async function fetchCatalog(): Promise<{ devices: Device[]; pricing_role?: PricingRole }> {
  const res = await client.get('/device-ordering/catalog', {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    params: { _: Date.now() },
  });
  return res.data as { devices: Device[]; pricing_role?: PricingRole };
}

export async function sendOtp(channel: 'email' | 'phone', email: string, phone: string) {
  const res = await client.post('/device-ordering/send-otp', { channel, email, phone });
  return res.data;
}

export async function verifyOtp(
  channel: 'email' | 'phone',
  email: string,
  phone: string,
  code: string,
): Promise<{ token?: string; pricing_role?: PricingRole; [key: string]: unknown }> {
  const res = await client.post('/device-ordering/verify-otp', { channel, email, phone, code });
  if (res.data?.token) setOrderingToken(res.data.token);
  return res.data;
}

export async function submitOrder(payload: any): Promise<{ ok: boolean; order_uid: string; total_minor: number; currency: string }> {
  const res = await client.post('/device-ordering/order', payload);
  return res.data;
}

export async function fetchCountries(): Promise<Country[]> {
  const res = await client.get('/meta/countries');
  return (res.data && res.data.countries) || [];
}


